import { TableContainer, 
        TableHead, 
        TableBody, 
        TableCell, 
        TableRow, 
        Paper,
        Table,
        Accordion,
        AccordionSummary,
        AccordionDetails
    } from "@mui/material";

import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import { useState } from "react";
import { ExpandMore } from "@mui/icons-material";

function BreakoutTab({scoreData, relatedConops, satisfiedReq, unsatisfiedReq}) {
    const [scoreDataExpanded, setScoreDataExpanded] = useState(true);
    const [relatedConopsExpanded, setRelatedConopsExpanded] = useState(false);
    const [satReqExpanded, setSatReqExpanded] = useState(false);
    const [unsatReqExpanded, setUnsatReqExpanded] = useState(false);

    return (
        <MDBox px={1} sx={{width:"100%"}}>
            {/* Bundle Scoring Table */}
            <Paper sx={{my: 1}}>
                <Accordion expanded={scoreDataExpanded} onChange={() => setScoreDataExpanded(!scoreDataExpanded)}>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <MDTypography variant="h5">Bundle Scoring</MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead sx={{ display: "table-header-group" }}>
                                    <TableRow>
                                        <TableCell>Cost</TableCell>
                                        <TableCell>Timeline</TableCell>
                                        <TableCell>Risk</TableCell>
                                        <TableCell>Cost&nbsp;Score</TableCell>
                                        <TableCell>Time&nbsp;Score</TableCell>
                                        <TableCell>Risk&nbsp;Score</TableCell>
                                        <TableCell>Overall&nbsp;Score</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {scoreData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.cost}</TableCell>
                                            <TableCell>{row.timeline}</TableCell>
                                            <TableCell>{row.risk}</TableCell>
                                            <TableCell>{row.costScore}</TableCell>
                                            <TableCell>{row.timeScore}</TableCell>
                                            <TableCell>{row.riskScore}</TableCell>
                                            <TableCell>{row.overallScore}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            </Paper>
            
            {/* Related Conops Table */}
            <Paper sx={{my: 1}}>
                <Accordion expanded={relatedConopsExpanded} onChange={() => setRelatedConopsExpanded(!relatedConopsExpanded)}>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <MDTypography variant="h5">Related ConOps</MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer sx={{maxHeight: 300}}>
                            <Table stickyHeader>
                                <TableHead sx={{ display: "table-header-group" }}>
                                    <TableRow>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {relatedConops.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.title}</TableCell>
                                            <TableCell>{row.description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            </Paper>

            {/* Satisfied Requirements Table */}
            <Paper sx={{my: 1}}>
                <Accordion expanded={satReqExpanded} onChange={() => setSatReqExpanded(!satReqExpanded)}>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <MDTypography variant="h5">Satisfied Requirements</MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer sx={{maxHeight: 300}}>
                            <Table stickyHeader>
                                <TableHead sx={{ display: "table-header-group" }}>
                                    <TableRow>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {satisfiedReq.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.title}</TableCell>
                                            <TableCell>{row.description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            </Paper>
            
            {/* Unsatisfied Requirements Table */}
            <Paper sx={{my: 1}}>
                <Accordion expanded={unsatReqExpanded} onChange={() => setUnsatReqExpanded(!unsatReqExpanded)}>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <MDTypography variant="h5">Unsatisfied Requirements</MDTypography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <TableContainer sx={{maxHeight: 300}}>
                            <Table stickyHeader>
                                <TableHead sx={{ display: "table-header-group" }}>
                                    <TableRow>
                                        <TableCell>Title</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {unsatisfiedReq.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{row.title}</TableCell>
                                            <TableCell>{row.description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </AccordionDetails>
                </Accordion>
            </Paper>
        </MDBox>
    )
}

export default BreakoutTab;